import { shape, string } from 'prop-types';

const openCloseShape = shape({
  open: string,
  close: string
});

export const storeShape = shape({
  address: shape({
    city: string,
    country: string,
    postalCode: string,
    state: string,
    street: string
  }),
  curbsidePickupHours: shape({
    sunday: openCloseShape,
    monday: openCloseShape,
    tuesday: openCloseShape,
    wednesday: openCloseShape,
    thursday: openCloseShape,
    friday: openCloseShape,
    saturday: openCloseShape
  }),
  distance: string,
  name: string,
  phone: string,
  proDeskPhone: string,
  storeDetailsPageLink: string,
  storeId: string,
  storeHours: shape({
    sunday: openCloseShape,
    monday: openCloseShape,
    tuesday: openCloseShape,
    wednesday: openCloseShape,
    thursday: openCloseShape,
    friday: openCloseShape,
    saturday: openCloseShape
  }),
  toolRentalPhone: string
});
